<template>
  <div class="p-enroll-result">
    <ucar-title type="confirmBack">{{title}}</ucar-title>
    <div v-if="enrollType" class="header overflow">
      <h2>{{enrollStatus[enrollType].title}}</h2>
      <p class="p-enroll-result-content" v-if="enrollStatus[enrollType].content">{{enrollStatus[enrollType].content}}</p>
      <!-- 头部显示地址等信息区域：需要判断司机招募类型 -->
      <div class="info" v-if="enrollType === '待面试'">
        <ucar-enroll-info
          :list="[{title:'面试时间',content: apiData.time},{title:'面试地点',content:apiData.address},{title:'携带证件',content:apiData.document}]"
        ></ucar-enroll-info>
      </div>
      <div class="info" v-if="enrollType === '待签约'">
        <ucar-enroll-info
          :list="[{title:'时间',content:apiData.time},{title:'地点',content:apiData.address},{title:'携带证件',content:apiData.document}]"
        ></ucar-enroll-info>
      </div>
      <div class="btn-group">
        <ucar-button @click="go('modify')" v-if="enrollType === '退回待修改'">修改信息</ucar-button>
        <ucar-button @click="bookInterview" v-if="enrollType === '待预约面试'">预约面试时间</ucar-button>
        <ucar-button
          @click="go('book-interview')"
          v-if="enrollType === '待面试' && apiData.isOpenAppoint"
        >修改面试时间</ucar-button>
      </div>
    </div>

    <ucar-middle-header
      v-if="enrollType"
      :list="infoList"
    ></ucar-middle-header>

    <div v-if="enrollType" class="pane">
      <!-- 第一步，报名成功 -->
      <!-- 报名失败 -->
      <ucar-enroll-fail
        :text="apiData.unapproveReason"
        :show-fail-reason="showFailReason"
        :enable-convert="enableConvert"
        :timeout="timeout"
        :driver-review-status="driverReviewStatus"
        :car-review-status="carReviewStatus"
        @refresh="refresh"
        @reTry="reTry"
        :status="status"
        v-if="enrollType !== '已签约' && enrollStatus[enrollType].step.length === 0"
      ></ucar-enroll-fail>
      <!-- 已经入职&合作完成 -->
      <ucar-enroll-over v-if="enrollType === '已签约'"></ucar-enroll-over>
      <!-- 报名流程 -->
      <ucar-process-flow
        v-if="enrollStatus[enrollType].step.length !== 0"
        :list="enrollStatus[enrollType].step"
        :current-step="currentStep"
      ></ucar-process-flow>
    </div>
    <ucar-share :show-share="sharePop" @cancelShare="share(false)"></ucar-share>
  </div>
</template>

<script>
import {
  EnrollStatusUPlus,
  EnrollStatusCompany,
  ServerTypeConverter
} from '../../utils/enroll-status'
import { getRecruitStatus, getUnapproveInfo } from '../../api'
import { transformDisapproveInfo, decodeCompanyId } from '../../utils/transform'

export default {
  name: 'enroll-result',
  data () {
    return {
      enrollType: '',
      status: '',
      sharePop: false,
      enableConvert: false,
      apiData: {
        driverName: '',
        isOpenAppoint: false,
        time: '',
        address: '',
        unapproveReason: '',
        joinMode: 1
      },
      infoList: [],
      showFailReason: true,
      driverReviewStatus: 0,
      carReviewStatus: 0,
      timeout: false
    }
  },
  computed: {
    currentStep () {
      const status = this.enrollStatus[this.enrollType]
      return status && status.step.length ? status.step.length : 0
    },
    enrollStatus () {
      return this.vuexJoinMode === 1 ? EnrollStatusUPlus : EnrollStatusCompany
    }
  },
  methods: {
    /**
     * 根据接口返回的状态码获取当前页面状态
     * @param serverStatus 服务器的招募状态
     * @returns {string}
     */
    typeConverter (serverStatus) {
      let key = this.vuexJoinMode === 1 ? 'uPlus' : 'company' // 个人优驾
      if (ServerTypeConverter[key].hasOwnProperty(serverStatus)) {
        return ServerTypeConverter[key][serverStatus]
      }
      // 不存在可显示状态中则将信息打印至控制台，方便开发人员调试
      console.info(ServerTypeConverter[key], serverStatus)
      // 匹配不到指向拒绝页面
      this.showFailReason = false
      return '报名失败'
    },
    reTry () {
      this.changeStatusToFillInfo()
      this.$router.push(this.vuexIndexUrl === '/' ? '/?reTry=true' : `${this.vuexIndexUrl}&reTry=true`)
    },
    go (to, global) {
      if (to === 'book-interview' || to === 'modify') { this.changeStatusToModifyInfo() }
      const id = this.vuexRecruitId // 报名id 传给 重新上传照片 & 预约面试时间
      if (to !== 'modify') {
        this.$router.push({ name: to, query: { id } })
      } else {
        this.$router.push({ name: this.vuexDisapproveInfo.errorType === 2 ? 'car-info' : 'person-info', query: { mode: 'modify' } })
      }
    },
    bookInterview () {
      if (this.apiData.isOpenAppoint) {
        this.go('book-interview')
        return
      }
      // 不可预约则提示
      this.$alert({
        content: '很抱歉，当前预约时间已过期',
        dsc: '请耐心等待，工作人员会再次为您发送预约通知',
        type: 'confirm'
      })
    },
    share (status) {
      this.sharePop = status
    },
    apiGetRecruitInfo () {
      // 获取招募状态
      getRecruitStatus(this.vuexRecruitId, this.vuexRegType).then(data => {
        this.setVuexRegType(`${data.recruitType}`)
        this.setVuexRecruitStatus({
          recruitStatus: data.recruitStatus,
          recruitCompoundStatus: data.recruitCompoundStatus
        })
        const status = this.vuexJoinMode === 1 ? data.recruitStatus : data.recruitCompoundStatus
        this.enrollType = this.typeConverter(status)
        this.enableConvert = data.toNoCar
        this.driverReviewStatus = data.driverReviewStatus
        this.carReviewStatus = data.carReviewStatus
        this.timeout = data.entDriverTimeout
        this.status = status
        this.apiData = data
        const typeEnum = [
          '',
          '神州全职司机',
          '无车加入',
          '带车加入',
          '企业无车优驾司机',
          '企业带车优驾司机'
        ]
        this.infoList = [
          {
            key: '姓名',
            value: data.driverName
          },
          {
            key: '加入方式',
            value: typeEnum[this.vuexRegType]
          }
        ]
        if (data.companyId) this.setVuexCompanyId(decodeCompanyId(data.companyId))
        if (status === 6 || status === 906 || status === 211 || status === 212 || status === 214) {
          return this.setVuexServiceCities(status === 906 ? { companyId: this.vuexCompanyId } : {})
            .then(() => {
              const currentCity = this.vuexServiceCities.find(item => item.cityId === `${data.locationCity}`)
              if (currentCity) {
                return this.setVuexCurrentCity({
                  ...currentCity,
                  id: currentCity.cityId,
                  name: currentCity.cityName
                })
              }
              return Promise.resolve(status)
            })
            .then(() => {
              return Promise.resolve(status)
            })
        }
        return Promise.resolve(status)
      }).then(status => {
        if (status === 4 || status === 904 || status === 214) {
          getUnapproveInfo(this.vuexRecruitId)
            .then(res => {
              this.setVuexDisapproveInfo(transformDisapproveInfo(res))
              const currentCity = this.vuexServiceCities.find(item => item.cityId === `${res.recruitInfo.locationCity}`)
              return this.setVuexCurrentCity({
                ...currentCity,
                id: currentCity.cityId,
                name: currentCity.cityName
              })
            })
        }
      })
    },
    refresh () {
      this.apiGetRecruitInfo()
    }
  },
  mounted () {
    if (!this.vuexRegType && this.$route.query.regType) this.setVuexRegType(this.$route.query.regType)
    if (this.$route.query.id) this.setVuexRecruitId(this.$route.query.id)
    this.apiGetRecruitInfo()
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";
.p-enroll-result {
  display: flex;
  flex-flow: column nowrap;
  .header {
    color: $ucar_main_color;
    background-color: $ucar_dark_bg;
    margin-bottom: 20px;
    overflow: hidden;
    min-height: 290px;
    &.overflow {
      margin-bottom: 0;
    }
    h2 {
      text-align: center;
      color: $ucar_main_color;
      margin: 60px 0 30px;
    }
    p {
      text-align: center;
      color: $ucar_assist_color;
      margin-bottom: 30px;

      &.p-enroll-result-content {
        padding: 0 30px;
        white-space: pre-wrap;
      }
    }
    .btn-group {
      margin: auto;
      width: 230px;
      text-align: center;
      display: flex;
      justify-content: center;
      .button {
        margin-bottom: 30px;
        & + .button {
          margin-left: 20px;
        }
      }
    }
    .info {
      padding: 0 50px 30px;
      color: $ucar_assist_color;
      line-height: 1.5;
    }
  }
  .middle-header {
    & + .pane {
      border-top: 0;
    }
  }
  .pane {
    display: flex;
    flex-flow: column nowrap;
    flex: 1 0 auto;
    margin: 0 $ucar_side_gutter;
  }
}
</style>
